<template>
  <div class="module-box" style="display:flex; gap:10px; width:100%; height: 410px;">
    <div style="flex: 0 1 25%; display:flex; flex-direction:column; gap:10px;">
      <dv-border-box-12 style="width:100%; height:200px;">
        <div style="display:flex; justify-content:center; align-items:center; height:100%; color:#fff;">
          累计攻击次数：
          <dv-digital-flop :config="screenData.totalAttack" style="width:120px; height:50px;" />
        </div>
      </dv-border-box-12>
      <dv-border-box-12 style="width:100%; height:200px;">
        <dv-conical-column-chart :config="screenData.protectionData" style="width:100%; height:180px;" />
      </dv-border-box-12>
    </div>

    <div style="flex: 0 1 50%; height: 100%; position: relative; overflow: hidden;">
      <TechEarth :map-config="screenData.mapData" />
    </div>

    <div style="flex: 0 1 25%">
      <dv-border-box-10 style="width:100%; height: 410px;">
        <div style="width:100%; height:100%; display:flex; justify-content:center; align-items:center;">
          <dv-scroll-board :config="screenData.attackBoard" style="width:96%; height:96%;"/>
        </div>
      </dv-border-box-10>
    </div>
  </div>
</template>

<script>
import TechEarth from '../components/TechEarth.vue';
import screenData from '../data/screenData.json';

export default {
  name: 'CenterPanel',
  components: { TechEarth },
  data() {
    return {
      screenData
    }
  }
}
</script>